export default __webpack_public_path__ + "static/media/grafema_f1rst_06.b6b4afb2.jpg";